<template>
  <div class="novice-guide-wraper">
    <!-- 引导弹窗 -->
    <div v-for="items in data" :key="items.id">
      <div v-if="bootSteps === items.id" class="novice-guide" :class="[items.class, isMsgsGlobal ? items.class+'34' : '' ]">
        <div class="novice-guide-mask"></div>
        <div class="novice-guide-content">
          <div class="colorBlue size16 weight600">{{ items.title }}</div>
          <div class="color666 size12 gj-mt20" v-if="items.text">{{ items.text }}</div>
          <div class="color333 size12 gj-mt20" v-if="items.textTwo">{{ items.textTwo }}</div>
          <div class="color_F77234 size12  gj-mt12" v-if="items.warning">{{items.warning}}</div>
          <div class="color333 size12  gj-mt12" v-if="items.content">{{ items.content }}</div>
          <div class="colorRed size12 gj-mt12" v-if="items.error">{{ items.error }}</div>
          <div class="flex justify-end">
            <template v-for="item in items.btnList">
              <gj-button v-if="item === 'skip'" :key="item" class="skipBtn" type="text" @click="skip">跳过</gj-button>
              <gj-button v-if="item === 'prevStep'" :key="item" class="prevStepBtn" type="text" @click="prevStep">上一条</gj-button>
              <gj-button v-if="item === 'nextStep'" :key="item" class="nextStepBtn" type="text" @click="nextStep">下一条</gj-button>
              <gj-button v-if="item === 'cancel'" :key="item" class="cancelBtn" type="text" @click="cancel">完成</gj-button>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {editUserConfig} from "@/api/user";
import {getAllMap} from "@/api/dashboard";
import {mapGetters} from "vuex";
export default {
  name: "novice-guide",
  data() {
    return {
      batchManagementGuide: '',
      bootSteps: 0, //步数
      data: [
        {
          id: 1,
          class: "novice-guide-first",
          title: "【重置成本】怎么用?！",
          text: "适合单个货件单个货件单的客户，灵活维护自己的成本。",
          content: "重置成本可以直接修改对应批次的采购成本与到库成本，不与发货单强制关联。假如您关联了发货单据，重置后的成本将不会对发货单生效~",
          error: "",
          btnList: ['skip', 'nextStep'],
        },
        {
          id: 2,
          class: "novice-guide-two",
          title: "【重算】怎么用?！",
          textTwo: "重算=重新生成批次与扣减，当您觉得系统内生成的批次数据有问题时，可通过重算重新生成。重算不会更改期初批次，仅对期初后批次进行重新生成，且重算日期不能超过期初生成日期。",
          content: "重算后的成本支持自定义选择哦~",
          error: "谨慎操作！！！",
          btnList: ['skip', 'prevStep', 'nextStep'],
        },
        {
          id: 3,
          class: "novice-guide-three",
          title: "【发货补录】怎么用?！",
          text: "适合没有使用系统供应链又想精准维护批次成本的客户。",
          warning: "适合场景：经常性的一个货件对应多个发货单，需要分发货单进行成本维护。",
          content: "如货件未关联发货单可通过发货补录进行统一成本维护，当线下一个货件对应多个发货单，则可以用发货补录将已接收库存数量拆分，分别维护成本。现系统仅支持对未关联发货单、closed状态的货件进行发货补录。",
          btnList: ['skip', 'prevStep', 'nextStep'],
        },
        {
          id: 4,
          class: "novice-guide-four",
          content: "扣减记录支持异常数据扣减，优化成本取值逻辑，避免丢失成本。",
          btnList: ['cancel'],
        }
      ],
    };
  },
  computed: {
    ...mapGetters({
      isMsgsGlobal: 'isMsgsGlobal',
    })
  },
  methods: {
    openNotice() {
      //判断页面，打开引导公告
      getAllMap().then(data => {
        this.batchManagementGuide = data?.batchManagementGuide ?? 'show';
        if (this.batchManagementGuide != 'hide') {
          this.batchManagementGuide = 'show'
          this.bootSteps = 1;
        }
      })
    },
    prevStep() {
      this.bootSteps--;
    },
    nextStep() {
      this.bootSteps++;
    },
    skip() {
      // 跳过引导
      this.bootSteps = 0;
    },
    cancel() {
      //关闭引导
      this.saveOrUpdate();
    },
    saveOrUpdate() {
      //接口取消步骤引导
      editUserConfig({
        name: 'batchManagementGuide',
        value: 'hide'
      }).then(res => {
        this.batchManagementGuide = 'hide';
        this.bootSteps = 0;
      })
    },
  },
};
</script>

<style scoped lang="scss">
.color_F77234 {
  color: #F77234;
}
.skipBtn {
  color: #1D2129;
}
.prevStepBtn {
  color: #666666;
}
.novice-guide {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 2000;
  width: 100%;
  height: 100%;
  min-width: 1366px;
  max-width: 1920px;
}

$top1: 149px;
$top2: 188px;
$top3: 245px;
$top34: 34px;

.novice-guide-content {
  font-family: PingFang SC;
  font-style: normal;
  padding: 20px 20px 12px;
  background: #ffffff;
  border: 1px solid #1f6eef;
  box-sizing: border-box;
  border-radius: 4px;
}
.novice-guide-first {
  .novice-guide-mask {
    position: absolute;
    left: 32px;
    top: $top1;
    z-index: 1000;
    width: 80px;
    height: 30px;
    box-shadow: rgba(0, 0, 0, 0.39) 0px 0px 0px 2005px;
  }
  .novice-guide-content {
    position: absolute;
    z-index: 1001;
    width: 321px;
    left: 32px;
    top: $top2;
  }
}
.novice-guide-first34 {
  .novice-guide-mask {
    top: $top1+$top34;
  }
  .novice-guide-content {
    top: $top2+$top34;
  }
}

.novice-guide-two {
  .novice-guide-mask {
    position: absolute;
    left: 125px;
    top: $top1;
    z-index: 1000;
    width: 54px;
    height: 30px;
    box-shadow: rgba(0, 0, 0, 0.39) 0px 0px 0px 2005px;
  }
  .novice-guide-content {
    position: absolute;
    z-index: 1001;
    width: 321px;
    left: 32px;
    top: $top2;
  }
}

.novice-guide-two34 {
  .novice-guide-mask {
    top: $top1+$top34;
  }
  .novice-guide-content {
    top: $top2+$top34;
  }
}

.novice-guide-three {
  .novice-guide-mask {
    position: absolute;
    left: 192px;
    top: $top1;
    z-index: 1000;
    width: 80px;
    height: 30px;
    box-shadow: rgba(0, 0, 0, 0.39) 0px 0px 0px 2005px;
  }
  .novice-guide-content {
    position: absolute;
    z-index: 1001;
    width: 321px;
    left: 192px;
    top: $top2;
  }
}

.novice-guide-three34 {
  .novice-guide-mask {
    top: $top1+$top34;
  }
  .novice-guide-content {
    top: $top2+$top34;
  }
}

.novice-guide-four {
  .novice-guide-mask {
    position: absolute;
    right: 58px;
    top: $top3;
    z-index: 1000;
    width: 62px;
    height: 30px;
    box-shadow: rgba(0, 0, 0, 0.39) 0px 0px 0px 2005px;
  }
  .novice-guide-content {
    position: absolute;
    z-index: 1001;
    width: 321px;
    right: 128px;
    top: $top3;
  }
}

.novice-guide-four34 {
  .novice-guide-mask {
    top: $top3+$top34;
  }
  .novice-guide-content {
    top: $top3+$top34;
  }
}

</style>